var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"typed-on-paper-tabs-padding"},[_c('DivLinkButton',_vm._b({staticClass:"typed-on-paper-tabs"},'DivLinkButton',{routeName: 'Ranks'},false),[_c('div',{staticClass:"heading"},[_vm._v("Ranks")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a3ed6fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/StructureSideNav.vue
// module id = null
// module chunks = 